// extracted by mini-css-extract-plugin
export default {"container":"TextView_container__Ndej9","name":"TextView_name__9WPKu","section":"TextView_section__bfASE"};